import type { ToastApi } from '~/components/AppToast.vue'

let _toastApi: ToastApi | null = null

export function registerToastApi(api: ToastApi): void {
    _toastApi = api
}

export function useToast() {
    function show(
        message: string,
        options?: number | { durationMs?: number; action?: { label: string; handler: () => void } },
    ): void {
        _toastApi?.show(message, options)
    }

    return { show }
}
